import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=4b86dcfd"
import script from "./Finalize.vue?vue&type=script&lang=js"
export * from "./Finalize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports